import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
const PartnerLoaderFirstChoice = () => {
  const $ = _c(5);
  const t = useTranslations("content");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <source srcSet="/static/images/first-choice-loader-static.gif" media="(prefers-reduced-motion: reduce)" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("partner_logo_first_choice");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="mx-auto max-w-[200px] md:max-w-[250px]"><picture>{t0}<img srcSet="/static/images/first-choice-loader-animated.gif" alt={t1} /></picture></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { PartnerLoaderFirstChoice };